import React, { useState,useRef } from "react";
import { Autocomplete, TextField, Chip, Popper } from "@mui/material";
import PropTypes from 'prop-types';

const CustomPopper = (props) => (
  <Popper
    {...props}
    modifiers={[
      {
        name: "preventOverflow",
        options: {
          boundary: "window",
        },
      },
    ]}
    onMouseDown={(event) => event.stopPropagation()} // ✅ Prevents closing on click
    onClick={(event) => event.stopPropagation()} // ✅ Prevents closing on click
  />
);

const AutocompleteFieldForMDV = ({ item, index, handlePropValueChange, textFieldRefs, handleKeyDown }) => {
  const [openMenuOption, setOpenMenuOption] = useState(false);
  const fieldRef = useRef(null); // 👉 ref to scroll to

  const scrollToField = () => {
    fieldRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "end", // or 'nearest' or 'start'
    });
  };
  let propValue;

  if (item.propType === "multi-list") {
    propValue = Array.isArray(item.propValue) ? item.propValue : [];
  } else {
    propValue = item?.propList?.includes(item.propValue) ? item.propValue : "";
  }

  return (
    <div ref={fieldRef}>
    <Autocomplete
      multiple={item.propType === "multi-list"}
      disableClearable={item.propType !== "multi-list"}
      ListboxProps={{
        sx: {
          fontSize: "12px",
          maxHeight: "150px",
          overflowY: "auto",
        },
      }}
      options={Array.isArray(item.propList) ? item?.propList?.filter((opt) => !item?.propValue?.includes(opt)) : []}
      value={propValue}
      onBlur={() => setOpenMenuOption(false)}
      open={openMenuOption}
      PopperComponent={CustomPopper}
      onFocus={() => {
        scrollToField();
        setOpenMenuOption(true);
      }}
      onOpen={() => {
        scrollToField();
        setOpenMenuOption(true);
      }}
      onClose={() => setOpenMenuOption(false)}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          event.stopPropagation();
        }
      }}
      onMouseDown={(e) => {
        // This triggers BEFORE blur/focus events
        setOpenMenuOption(true);
      }}
      onChange={(event, newValue) => {
        event.stopPropagation();
        handlePropValueChange(index, newValue);
        if (item.propType !== "multi-list") {
          setOpenMenuOption(false);
        }
      }}
      disableCloseOnSelect={item.propType === "multi-list"}
      renderTags={(value, getTagProps) =>
        openMenuOption
          ? value.map((option, index) => (
              <Chip {...getTagProps({ index })} key={option} label={option} 
              sx={{
                fontSize: "12px",
                height: "16px", // ✅ Set exact height
                minHeight: "16px", // ✅ Override default minHeight
                padding: "0px 4px", // ✅ Reduce padding to fit inside 16px
                borderRadius: "8px",
                marginRight: "2px",
                "& .MuiChip-root" :{
                  height: "16px"
                },
                "& .MuiChip-label" : {
                  paddingLeft: "5px",
                  paddingRight: "5px"
                },
                "& .MuiChip-deleteIcon": {
                  fontSize: "14px", // ✅ Reduce cross icon size
                  margin: "0px 3px 0px 0px"
                },
              }}/>
            ))
          : value.map((option) => (
              <Chip key={option} label={option} className="dropdown-chip-style"
               sx={{
                fontSize: "12px",
                height: "16px", // ✅ Set exact height
                minHeight: "16px", // ✅ Override default minHeight
                padding: "0px 6px", // ✅ Reduce padding to fit inside 16px
                borderRadius: "8px",
                marginRight: "2px",
                "& .MuiChip-root" :{
                  height: "16px"
                },
                "& .MuiChip-label" : {
                  paddingLeft: "5px",
                  paddingRight: "5px"
                }, // ✅ Set font size of chip text
                "& .MuiChip-deleteIcon": {
                  fontSize: "14px", // ✅ Reduce cross icon size
                },
              }} />
            ))
      }
  renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          size="small"
          sx={{
            ".MuiAutocomplete-input": {
              height: "11px",
              fontSize: "12px",
            },
          }}
          onClick={(event) => event.stopPropagation()}
          onFocus={() => setOpenMenuOption(true)}
          onBlur={() => setOpenMenuOption(false)}
          inputRef={(el) => {
            textFieldRefs.current[`main_${index}`] = el;
          }}
          onKeyDown={(event) => {
            if (event.key === "Tab") {
              event.preventDefault();
              event.stopPropagation();
              handleKeyDown(`main_${index}`, event);
            }
          }}
        />
      )}
    /></div>
  );
};

AutocompleteFieldForMDV.propTypes = {
  item: PropTypes.shape({
    propName: PropTypes.string,
    propAbbrevation: PropTypes.string,
    propValue: PropTypes.any,
    propType: PropTypes.string,
    propBgColor: PropTypes.string,
    propFgColor: PropTypes.string,
    propList: PropTypes.any // Adjust if propValue can be another type
  }).isRequired,
  index: PropTypes.number.isRequired,
  handlePropValueChange: PropTypes.func.isRequired,
  handleKeyDown: PropTypes.func.isRequired,
  textFieldRefs: PropTypes.object.isRequired,
}

export default AutocompleteFieldForMDV;
